/**
 * Maps host-provided feedback history onto accordion thumb UI (`up` / `down` / null).
 */

import type { AgenticFeedbackEntry, AgenticFeedbackHistoryResponse } from '../AskAsperAgentic.types';

function thumbsUpToInitialVote(thumbs: AgenticFeedbackEntry['thumbs_up']): 'up' | 'down' | null {
    if (thumbs === 'like') return 'up';
    if (thumbs === 'dislike') return 'down';
    return null;
}

function findRunRow(history: AgenticFeedbackHistoryResponse | undefined, runId: string | undefined) {
    if (!history?.runs?.length || !runId) return undefined;
    return history.runs.find((r) => r.run_id === runId);
}

/** Query-level feedback: entry with matching run_id and no task_id. */
function findQueryFeedbackEntry(
    history: AgenticFeedbackHistoryResponse | undefined,
    runId: string | undefined,
): AgenticFeedbackEntry | undefined {
    const row = findRunRow(history, runId);
    if (!row?.feedback?.length) return undefined;
    return row.feedback.find((e) => e.run_id === runId && e.task_id == null);
}

function findTaskFeedbackEntry(
    history: AgenticFeedbackHistoryResponse | undefined,
    runId: string | undefined,
    taskId: string,
): AgenticFeedbackEntry | undefined {
    const row = findRunRow(history, runId);
    if (!row?.feedback?.length) return undefined;
    return row.feedback.find((e) => e.task_id === taskId);
}

export function getInitialVoteForSummary(
    history: AgenticFeedbackHistoryResponse | undefined,
    runId: string | undefined,
): 'up' | 'down' | null {
    const e = findQueryFeedbackEntry(history, runId);
    return e ? thumbsUpToInitialVote(e.thumbs_up) : null;
}

export function getInitialVoteForTask(
    history: AgenticFeedbackHistoryResponse | undefined,
    runId: string | undefined,
    taskId: string,
): 'up' | 'down' | null {
    const e = findTaskFeedbackEntry(history, runId, taskId);
    return e ? thumbsUpToInitialVote(e.thumbs_up) : null;
}
